import { render, staticRenderFns } from "./CercheckSeefzorgansec.vue?vue&type=template&id=5553f860&scoped=true&"
import script from "./CercheckSeefzorgansec.vue?vue&type=script&lang=js&"
export * from "./CercheckSeefzorgansec.vue?vue&type=script&lang=js&"
import style0 from "./CercheckSeefzorgansec.vue?vue&type=style&index=0&id=5553f860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553f860",
  null
  
)

export default component.exports